// Copyright (c) 2024 James Reid. All rights reserved.
//
// This source code file is licensed under the terms of the MIT license, a copy
// of which may be found in the LICENSE.md file in the root of this repository.
//
// For a template copy of the license see one of the following 3rd party sites:
//      - <https://opensource.org/licenses/MIT>
//      - <https://choosealicense.com/licenses/mit>
//      - <https://spdx.org/licenses/MIT>

/**
 * @file Create standard WebGL renderer and append to DOM container.
 * @author James Reid
 */

// @ts-check

// @@imports-dependencies
import * as THREE from "three"

// @@body
/**
 *
 * @param {HTMLElement} container
 * @returns {THREE.WebGLRenderer}
 */
const getRenderer = container => {
    const renderer = new THREE.WebGLRenderer()
    renderer.setSize(container.offsetWidth, container.offsetHeight)
    container.appendChild(renderer.domElement)

    return renderer
}

// @@exports
export { getRenderer }
